import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User deleted a context value',
  name: 'context_value_deleted',
  params: [
    {
      description: 'The source of the deletion',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['manual'],
    },
    {
      description: 'The value type of the field',
      name: 'value_type',
      required: true,
      type: 'enum',
      values: ['text', 'file', 'color', 'font'],
    },
    {
      description: 'The name of the field',
      name: 'field_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
